import type { GalleryConfigConfig } from 'shared/types/gallery/config'

const configInstance = process.env.CONFIG as unknown as GalleryConfigConfig

export const config = configInstance
export default config
